<script setup lang="ts">
    /**
     * 📘docs: https://onewoom.atlassian.net/wiki/spaces/ECOM/pages/1645936641
     */
    const props = defineProps<IWidgetProps<SearchResultsWidgetData>>();
    const { cmsComponentProps } = useWidget(props);
</script>
<template>
    <lazy-org-search-result-products
        v-if="data.search_query?.data?.query"
        v-bind="cmsComponentProps" />
</template>
